<template>
  <div style="max-width:900px; margin: auto;">
 <br />
  
    <h2>{{ $t('events') }}</h2>

   <hr />
    <router-link  to="/broadcaster/createEvent" class="btn btn-dark">{{ $t('create-event') }}</router-link> <br /><br />
    <div v-if="eventList">
  
     <p v-if="eventList.length==0"> {{ $t('no-past-events') }}</p>
<div class="row">
  <!-- use pagination to show events in eventList, get more events on scroll -->
  <div class="col-md-6 p-2" v-for="event in eventList" v-bind:key="event.id" >
      <recording style="cursor:pointer" :event="event" :channel_id="channel.id" @clicked="$router.push('/broadcaster/event/'+event.id)" >
    </recording> 
</div>
</div>
</div>
 <div v-else>
  <p class="w-100 text-center"> {{ $t('loading-events') }}</p> 
               <scale-loader  :color="'darkblue'" ></scale-loader>

   </div>
</div>


</template>

<script>
import recording from '../Event.vue'
import axios from "axios"
import Swal from "sweetalert2"
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
let API = "https://app.seasoncast.com/"


export default {
  name: 'Home',
  props: ['channel'],
  components: {
    recording,
    ScaleLoader
  },
  
  data: function () {
    return {
      recordingsList: [],
        eventList: [],
        isLoaded: false,
        currentPos: 0,
    }
  },
  watch: {
    channel: function () {
      this.getChannelRecordings()
    }
  },
  mounted: function () {
    //add pagination on scroll
    window.onscroll = this.eventsScroll


  },
  destroyed: function () {
     window.onscroll = null
  },
  created: async function () {


await this.getChannelRecordings(this.eventList.length, 50)

  },

  methods: { 
    eventsScroll() {
     let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          this.getChannelRecordings(this.eventList.length, 50)
        }
    },
    // use pagination to show events in eventList
    getChannelRecordings: async function (start, end) {
      console.log(this.channel.id)
    let getEventResponse = await axios.post(API+ "v2/channel/events", {
    channel_id: this.channel.id,
    start: start,
    end: end
  }) 

  let responseData = getEventResponse.data
this.isLoaded = true
  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: 'Try action later or refresh page'
})

  }
console.log(responseData, 'start:'+start, 'end: '+end)
  this.eventList.push(...responseData.snippets)



    },
  }
}
</script>
<style lang="scss">
.container {
    max-width: 1100px;
}
</style>
